"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Header = _interopRequireDefault(require("./Header"));

var _DayPicker = _interopRequireDefault(require("./DayPicker"));

var _TodayPicker = _interopRequireDefault(require("./TodayPicker"));

var _Calendar = _interopRequireDefault(require("./Calendar.scss"));

var _moment = _interopRequireDefault(require("moment"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var Calendar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Calendar, _React$Component);

  function Calendar() {
    (0, _classCallCheck2.default)(this, Calendar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Calendar).apply(this, arguments));
  }

  (0, _createClass2.default)(Calendar, [{
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: _Calendar.default.calendar,
        style: this.props.style,
        onMouseDown: this.props.onMouseDown,
        onMouseUp: this.props.onMouseUp,
        ref: function ref(div) {
          return _this.div = div;
        }
      }, _react.default.createElement(_Header.default, {
        value: this.props.value,
        monthName: this.props.monthName,
        leftArrow: this.props.leftArrow,
        rightArrow: this.props.rightArrow,
        onChange: this.props.onChange,
        onClick: this.props.onHeaderClick
      }), _react.default.createElement(_DayPicker.default, {
        value: this.props.value,
        onChange: this.props.onChange,
        daysOfTheWeek: this.props.daysOfTheWeek,
        isDateTime: this.props.isDateTime
      }), _react.default.createElement(_TodayPicker.default, {
        onChange: this.props.onChange,
        value: this.props.localToday,
        isDateTime: this.props.isDateTime
      }));
    }
  }]);
  return Calendar;
}(_react.default.Component);

;
Calendar.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * A working instance of a moment Object. Note that this value is not the same as the "value" displayed in the
   * DatePicker's text field but instead should represent the date associated with the state in CwDatePicker.
   */
  value: _propTypes.default.instanceOf(_moment.default),

  /**
   * An array of localized months
   */
  monthName: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * An array of localized days of the week
   */
  daysOfTheWeek: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * The localized version of the word today
   */
  localToday: _propTypes.default.string,

  /**
   * A function to handle updating the text field should at least update the value
   */
  onChange: _propTypes.default.func,

  /**
   * url for the left arrow image
   */
  leftArrow: _propTypes.default.string,

  /**
   * url for the right arrow image
   */
  rightArrow: _propTypes.default.string,

  /**
   * A function responsible for handling the arrow clicks in the header
   */
  onHeaderClick: _propTypes.default.func,

  /**
   * A function to handle mouse down events, useful for tracking when someone clicks off the calendar
   */
  onMouseDown: _propTypes.default.func,

  /**
   * A function to handle the mouse up event, useful for tracking when someone clicks off the calendar
   */
  onMouseUp: _propTypes.default.func,

  /**
   * Set of style properties to determine the calendar's position. Must contain left and top
   */
  style: _propTypes.default.shape({
    left: _propTypes.default.number,
    top: _propTypes.default.number
  })
};
Calendar.defaultProps = {
  leftArrow: _IconPath.default.get('Action_Back'),
  rightArrow: _IconPath.default.get('Action_Forward')
};
var _default = Calendar;
exports.default = _default;